const trimTrailingSlashes = (value) => value.replace(/\/+$/, '');

/**
 * The URL at which the host mounted People & Access (`…/people-access`), derived from the
 * current pathname and the host route's splat (`useParams()['*']`).
 *
 * Redirects and tab navigation build absolute URLs from it instead of relying on relative
 * `<Navigate to="members">`: with `v7_relativeSplatPath` (enabled by Core Shell and the
 * standalone bootstrap) a relative target inside a catch-all route resolves against the
 * whole splat and redirects forever. The mount point stays unhardcoded (embed contract).
 *
 * @param {string} pathname Current `location.pathname`.
 * @param {string} [splat] The host route's `*` param (path below the mount point).
 */
export const getBasePath = (pathname, splat = '') => {
  const path = trimTrailingSlashes(pathname);
  const rest = trimTrailingSlashes(splat);

  return rest ? trimTrailingSlashes(path.slice(0, path.length - rest.length)) : path;
};
